import { initialWindowMetrics } from 'react-native-safe-area-context';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isAndroid } from '@global/screens';

// buttonFloating is a plain style object, not a component, so it cannot use
// useSafeAreaInsets. initialWindowMetrics is populated synchronously from native
// constants at startup and is null on web. This is a snapshot: it does not track
// a rotation that changes the bottom inset.
const bottomInset = isAndroid ? initialWindowMetrics?.insets?.bottom ?? 0 : 0;

const button = {
  width: '100%',
  backgroundColor: Colors.blue0,
  borderRadius: 5,
  borderWidth: 1,
  color: '#FFFFFF',
  height: Colors ? 36 : 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderColor: Colors.blue0,
  padding: 0,
};

const buttonDisabled = {
  backgroundColor: '#e5e5e5',
  borderColor: '#e5e5e5',
};

const buttonText = {
  fontSize: 13,
  lineHeight: 19,
  fontFamily: 'figtree-bold',
  color: '#FFFFFF',
  letterSpacing: 0.5,
};

const buttonTextDisabled = {
  color: '#FFFFFF',
};

const buttonMain = {
  width: '100%',
  backgroundColor: '#3346AF',
};

const buttonPrimary = {
  width: '100%',
  backgroundColor: Colors.blue3,
  borderColor: Colors.blue3,
};

const buttonDanger = {
  width: '100%',
  backgroundColor: Colors.red1,
  borderColor: Colors.red1,
};

const buttonGrey = {
  width: '100%',
  backgroundColor: Colors.grey5,
  borderColor: Colors.grey5,
};

const buttonDefault = {
  width: '100%',
  backgroundColor: Colors.white,
  borderColor: Colors.grey0,
};

const buttonFloating = {
  width: '100%',
  padding: 15,
  // Must come after padding so it overrides the bottom side only.
  paddingBottom: 15 + bottomInset,
  backgroundColor: Colors.white,
  position: isWeb ? 'fixed' : isMobileWeb ? 'sticky' : 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 3,
  elevation: 3,
};

const buttonRow = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const buttonRounded = {
  position: 'relative',
  borderRadius: 8,
};

const buttonOutlinePrimary = {
  backgroundColor: 'transparent',
  color: Colors.blue1,
  borderColor: Colors.blue1,
  borderWidth: 2,
};

export {
  button,
  buttonDisabled,
  buttonText,
  buttonTextDisabled,
  buttonMain,
  buttonPrimary,
  buttonGrey,
  buttonFloating,
  buttonRow,
  buttonRounded,
  buttonDanger,
  buttonOutlinePrimary,
  buttonDefault,
};
